export default "__VITE_ASSET__C$T2b4IE__"